import { DynamicFormV2Palette } from "@mui/material";

export type GiftAidBlockComponentTokenType = {
  backgroundColor: string;
  borderColor: string;
  textColor: string;
  headerTextColor: string;
  headerTextColorReverse: string;
  contentTextColor: string;
  iconColor: string;
  alertBackgroundColor: string;
  alertTextColor: string;
  borderErrorColor: string;
};

export const assignGiftAidBlockComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark"
) => {
  const isLightMode = mode === "light";

  return {
    backgroundColor: isLightMode ? formsPalette.surface.quiet : formsPalette.surface.moderate,
    borderColor: formsPalette.border.moderate,
    textColor: formsPalette.text.moderate,
    headerTextColor: isLightMode ? formsPalette.text.brand : formsPalette.text.moderate,
    headerTextColorReverse: isLightMode ? formsPalette.text.moderate : formsPalette.text.brand,
    contentTextColor: formsPalette.text.moderate,
    iconColor: formsPalette.text.brand,
    alertBackgroundColor: isLightMode ? formsPalette.surface.quiet : formsPalette.surface.intense,
    alertTextColor: formsPalette.text.brand,
    borderErrorColor: formsPalette.border.error,
  };
};
